export const JWT_PUBLIC = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuQ/2Xl1YFw+NTTzZk/iW
cl+X22XB4741oljKijbY7YjBiwWGrv4tjfpuxQDOslX9Qv6858Ls/zXn+xW9m8hr
kZEj6ADDx5yO4q7Oz7WCFm+5PcsQLTik4b87+LusmY6F5G/RQKCgAAeyoZN99mwW
NgFXg6Q1O/AbeK5kZqtr6PMXCgZ/LBRNOKRjIYCfV7RaydoKtCei2fomXRnrJBTo
N16gx5bcd5wPLQXkhovSBRqS/JRhCcaD4MHxWYCG7tRQD7Qg/oC0V2ZD/N9Pr88D
3RRtoFmJewIhsCcT+SBAIJxEeSA421p4+nTbNCKaGy/8NCjWw5PzGqO/TUHLmrC4
5wIDAQAB
-----END PUBLIC KEY-----`;
